import { render, staticRenderFns } from "./IconDeactivate.vue?vue&type=template&id=6b0d96b3"
import script from "./IconDeactivate.vue?vue&type=script&lang=js"
export * from "./IconDeactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports